/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020-2024 (original work) Open Assessment Technologies SA ;
 */

/**
 * Try to find the closest parent element which is a block, recursively
 * @param {HTMLElement} element - the element to check the parent
 * @returns {HTMLElement?} the parent element or null
 */
export function findClosestBlockParent(element) {
    const parent = element && element.parentElement;
    if (parent) {
        const display = window.getComputedStyle(parent).display;
        if (!['none', 'inline', 'inline-block'].includes(display)) {
            return parent;
        } else if (!['BODY', 'HTML', 'HEAD'].includes(parent.nodeName)) {
            return findClosestBlockParent(parent);
        }
    }
    return null;
}
